import { Selectable } from './selectable';
import { TransformerType } from './enums';
import { DrEntityAttribute } from './dr-entity-attribute';

export class LoadFileMetadataProfileCompositeFieldMember {
    fieldName: string;
    fieldType: string;
    fieldValue: string;
}
export class FieldMapping extends Selectable {
    transformerAttributes: Array<DrEntityAttribute>;
    digitalReefMetadataValue: string;
    composite: boolean;
    compositeFields: Array<LoadFileMetadataProfileCompositeFieldMember>;

    // off-model display values
    iconColor = 'color-blue-01';
    iconClass = this.getIconByTransformerType();

    private _fieldTransformerType: TransformerType;
    set fieldTransformerType(transType: TransformerType) {
        if (transType) {
            this._fieldTransformerType = transType;
            this.iconClass = this.getIconByTransformerType();
        }
    }
    get fieldTransformerType(): TransformerType {
        return this._fieldTransformerType;
    }

    constructor(value?: Partial<FieldMapping>) {
        super(value);
        if (value) {
            // at backed number transformers are saved as text transformers, for UI purposes need to differentiate between types that's why I'm allocating a temp type
            if (value.fieldTransformerType === TransformerType.text && value.transformerAttributes
                && value.transformerAttributes.length === 1 && value.transformerAttributes[0].name === 'CONVERT_FILE_SIZE') {
                    value.fieldTransformerType = TransformerType.number;
            }
            Object.assign(this, value);
        }
    }

    getIconByTransformerType(): string {
        let faName = null;
        switch (this._fieldTransformerType) {
            case TransformerType.number:
                faName = 'fa-hashtag';
                this.iconColor = 'color-blue-01';
                break;
            case TransformerType.text:
                faName = 'fa-font';
                this.iconColor = 'color-blue-01';
                break;
            case TransformerType.date:
                faName = 'fa-calendar';
                this.iconColor = 'color-blue-01';
                break;
            case TransformerType.none:
                faName = 'fa-long-arrow-right';
                this.iconColor = 'color-grey-08';
                break;
        }
        return faName;
    }
}
